// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1gdUm","right":"styles_right__qPntM"};